/* global moment */
import { useEffect, useRef } from "react";

export const DatePicker = ({
  setValue,
  value,
  parentElem = "",
  placeholder,
}) => {
  const datePickerRef = useRef(null);
  useEffect(() => {
    datePickerRef.current.flatpickr({
      monthSelectorType: "static",
      locale: "fa",
      altInput: true,
      altFormat: "Y/m/d",
      disableMobile: true,
      onChange: function (selectedDates, dateStr, instance) {
        const m = moment.from(dateStr, "fa", "jYYYY-jMM-jDD");
        const miladiDate = m.format("YYYY-MM-DD");
        setValue(miladiDate);
      },
    });
  }, []);

  return (
    <input
      ref={datePickerRef}
      type="text"
      className="form-control"
      placeholder={placeholder || "انتخاب تاریخ"}
      id="flatpickr-date"
    />
  );
};

export const DatePickerRange = ({
  setValue,
  setStartDate,
  setEndDate,
  value,
  parentElem = "",
  placeholder,
}) => {
  const datePickerRef = useRef(null);
  useEffect(() => {
    datePickerRef.current.flatpickr({
      mode: "range",
      monthSelectorType: "static",
      locale: "fa",
      altInput: true,
      altFormat: "Y/m/d",
      disableMobile: true,
      onChange: function (selectedDates, dateStr, instance) {
        const dates = dateStr.split(" تا ");
        if (dates.length < 2) return;

        const startJalali = dates[0];
        const endJalali = dates[1];

        const startMiladi = moment
          .from(startJalali, "fa", "jYYYY/jMM/jDD")
          .format("YYYY-MM-DD");
        const endMiladi = moment
          .from(endJalali, "fa", "jYYYY/jMM/jDD")
          .format("YYYY-MM-DD");

        if (setValue) setValue([startMiladi, endMiladi]);
        if (setStartDate) setStartDate(startMiladi);
        if (setEndDate) setEndDate(endMiladi);
      },
    });
  }, []);
  return (
    <input
      ref={datePickerRef}
      type="text"
      className="form-control"
      placeholder={placeholder || "انتخاب تاریخ"}
      id="flatpickr-date"
    />
  );
};
